<template>
  <div>
    <canvas id="chartCanvas" width="360" height="200" style="display: none"></canvas>
    <PageHeader title="รายงานการเข้าเรียนรายบุคคล"></PageHeader>
    <b-container>
        <div class="py-2"></div>
        <div class="no-data" v-if="isDisplayNoData">
          ไม่พบข้อมูลรายงานการเข้าเรียน กรุณาเลือกชื่อ/อีเมลของผู้เรียน ชื่อคอร์ส หรือ ข้อมูลเดือน อีกครั้ง
        </div>
        <div class="py-3">
          <div class="inner bg-container">
            <div style="display: flex">
              <h6 style="margin-right: 150px; display: inline">
                <strong class="pre-formatted">กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน </strong>
              </h6>
            </div>
            <div class="mt-5">
              <h6 class="mb-3"><strong>ชื่อ/อีเมล ผู้เรียน</strong></h6>
              <v-select
                :options="membersData"
                v-model="selectedMember"
                placeholder="พิมพ์ชื่อผู้เรียนที่ต้องการค้นหา..."
                :disabled="!membersData.length"
                :clearable="false"
              />
            </div>
            <b-row class="mt-5">
              <b-col cols="3">
                <h6 class="mb-3"><strong>สถานะหลักสูตร</strong></h6>
                <v-select
                  :options="coursesStatusOptions"
                  v-model="selectedCoursesStatus"
                  placeholder="เลือกสถานะ"
                  :disabled="!selectedMember"
                  :clearable="false"
                  :searchable="false"
                />
              </b-col>
              <b-col cols="9">
                <h6 class="mb-3"><strong>ชื่อคอร์สที่เข้าเรียน</strong></h6>
                <v-select
                  :options="CourseOptions"
                  v-model="selectedCourseEnroll"
                  placeholder="พิมพ์ชื่อคอร์สที่ต้องการค้นหา..."
                  :disabled="!selectedCoursesStatus"
                  :clearable="false"
                />
              </b-col>
            </b-row>
            <span v-show="!!selectedCourseEnroll && startLearningDate" style="font: italic normal normal 12px/18px Prompt; letter-spacing: 0px; color: #027BFF;">
              ช่วงเวลาที่เข้าเรียน: {{ startLearningDate }} - {{ lastLearningDate ?? startLearningDate }}
            </span>
            <span v-show="!!selectedCourseEnroll && !startLearningDate" style="font: italic normal normal 12px/18px Prompt; letter-spacing: 0px; color: red;">
              ไม่พบข้อมูลรายงานการเข้าเรียน เนื่องจากผู้เรียนไม่มีประวัติการเข้าเรียน
            </span>
            <div class="mt-5">
              <h6 class="mb-3"><strong>ข้อมูลเดือน</strong></h6>
              <div class="datepickers-container">
                <datepicker
                  v-model="selectedStartMonth"
                  placeholder="เลือกเดือนที่เข้าเรียน"
                  :buddhist="true"
                  :format="format"
                  :language="languages.th"
                  :minimumView="'month'" :maximumView="'year'"
                  :disabled-dates="state.disabledStartMonth"
                  :disabled="startMonthDisabled || !startLearningDate"
                  @input="handleStartMonthChange"
                />
                <label>ถึง</label>
                <datepicker
                  v-model="selectedEndMonth"
                  placeholder="เลือกเดือนที่เข้าเรียน"
                  :buddhist="true"
                  :format="format"
                  :language="languages.th"
                  :minimumView="'month'" :maximumView="'year'"
                  :disabled-dates="state.disabledEndMonth"
                  :disabled="endMonthDisabled || !startLearningDate"
                  @input="handleEndMonthChange"
                />
              </div>
            </div>
            <div class="mt-5">
              <b-button variant='primary' :disabled="!selectedEndMonth || !startLearningDate" @click="checkUserData()"><i class="fa fa-search" aria-hidden="true"></i> ค้นหาข้อมูล </b-button>
            </div>
            <template v-if="courseCanDownload.length <= 0  && showDownload">
              <div class="no-data">
                ไม่พบข้อมูลรายงานการเข้าเรียน กรุณาเลือกชื่อ/อีเมลของผู้เรียน ชื่อคอร์ส หรือ ข้อมูลเดือน อีกครั้ง
              </div>
            </template>
            <template v-else-if="selectedCourseEnroll?.value === 'all' && selectedEndMonth && showDownload">
              <div class="mt-5" >
                <b-row class="border-bottom pb-2 mb-3">
                  <b-col cols="8" class="d-flex align-items-center">
                    <strong>
                      รายงานการเข้าเรียนของ {{ selectedMember.label }} ทั้งหมด {{ courseCanDownload.length }} คอร์ส
                    </strong>
                  </b-col>
                  <b-col cols="4">
                    <div class="d-flex justify-content-end">
                      <MemberEnrollAttendanceReportPDF
                        :mId="mId"
                        :cerId="cerId"
                        :start="range.start"
                        :end="range.end"
                        :text="ดาวน์โหลดรายงานรวมทุกคอร์ส"
                        :btnDisabled=false
                        :status="cStatus"
                        @no-data="handleNoData"
                      ></MemberEnrollAttendanceReportPDF>
                    </div>
                  </b-col>
                  <hr/>
                </b-row>
                
                <b-row v-for="course in courseCanDownload" :key="course.cerId" class="border-bottom pb-2 mb-3">
                  <b-col cols="8" class="d-flex align-items-center"> {{ course.courseName }} </b-col>
                  <b-col cols="4" class="text-end">
                    <div class="d-flex justify-content-end">
                        <MemberEnrollAttendanceReportPDF
                            :mId="mId"
                            :cerId="course.cerId"
                            :start="range.start"
                            :end="range.end"
                            :btnDisabled=false
                            :status="cStatus"
                            @no-data="handleNoData"
                        ></MemberEnrollAttendanceReportPDF>
                    </div>
                  </b-col>
                  
                  <hr />
                </b-row>
              </div>
            </template>
            <template v-else-if="selectedEndMonth && showDownload">
              <div class="mt-5" >
                <b-row class="border-bottom pb-2 mb-3">
                  <b-col cols="8" class="d-flex align-items-center">
                    <strong>
                      รายงานการเข้าเรียนของ {{ selectedMember.label }}
                    </strong>
                  </b-col>
                  <b-col cols="4">
                    <div class="d-flex justify-content-end">
                      <MemberEnrollAttendanceReportPDF
                        :mId="mId"
                        :cerId="cerId"
                        :start="range.start"
                        :end="range.end"
                        :btnDisabled=false
                        :status="cStatus"
                        @no-data="handleNoData"
                      ></MemberEnrollAttendanceReportPDF>
                    </div>
                  </b-col>
                  <hr/>
                </b-row>
              </div>
            </template>
          </div>
        </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import MemberEnrollAttendanceReportPDF from "../../reports/attendance-report/MemberEnrollAttendanceReportPDF";
import api from "@/services/api.js";
import vSelect from "vue-select";
import Datepicker from 'vuejs-datepicker-thai';
import * as lang from "vuejs-datepicker-thai/src/locale";
import dateMixins from "@/components/pages/analytics/shared/mixins/date.js";

export default {
  components: { PageHeader, vSelect, 
    MemberEnrollAttendanceReportPDF, 
    Datepicker},
  mixins: [dateMixins],
  props: {
    company: {
      type: Object,
      default: null,
    },
    user: { default: null, type: Object },
  },
  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      membersData: [],
      CourseOptions: [],
      CourseData: [],
      coursesStatusOptions: [
        { label: "สถานะทั้งหมด", value: "*" },
        { label: "กำลังเผยแพร่", value: "PUBLISH" },
        { label: "พักการเผยแพร่", value: "SUSPEND" }
      ],
      selectedCoursesStatus: null,
      mId: null,
      cerId: null,
      cStatus: null,
      selectedMember: null,
      selectedCourseEnroll: null,
      selectedMonth: null,
      selectedStartMonth: null,
      selectedEndMonth: null,
      startMonthDisabled: true,
      endMonthDisabled: true,
      format: "MMMM yyyy",
      range: {
        start: "",
        end: ""
      },
      languages: lang,
      hasMembersData: true,
      btnDisabled: true,
      isDisplayNoData: false,
      state : {
        disabledStartMonth: {
          // to: new Date(2016, 0, 5),
          from: new Date(),
        },
        disabledEndMonth: {
          to: null,
          from: new Date(),
        }
      },
      allCourse: { label: "คอร์สทั้งหมด", value: 'all' },
      startLearningDate: null,
      lastLearningDate: null,
      showDownload: false,
      courseCanDownload: [],
    };
  },
  computed: {
  },
  async created() {
    await api.get(`/v1/companies/${this.comId}/enrolled-members`).then(({ data }) => {
      this.membersData = data.map(member => ({ label: member.mp_firstName + ' ' + member.mp_lastName + ' (' + member.m_email + ') ', value: member.m_id }));
      this.hasMembersData = false;
    });
  },
  watch: {
    selectedMember(newMember) {
      this.mId = newMember.value;
      this.fetchCourseDate();
    },
    selectedCoursesStatus(newStatus) {
      this.cStatus = newStatus.value;
      this.fetchCourseDate();
    },
    selectedCourseEnroll(newCourse) {
      if (newCourse !== null) {
        this.selectedCourseEnroll = newCourse;
        this.selectedStartMonth = null;
        this.selectedEndMonth = null;
        this.startMonthDisabled = false;
        this.cerId = newCourse.value;
      }

      if (newCourse.value === 'all') {
        this.calculateAllCoursesLearningDate(this.CourseData);
      } else {
        const course = this.CourseData.find(course => course.cerId === newCourse.value)
        this.calculateCourseLearningDate(course);
      }

      this.enableBtnReport();
    },
  },
  mounted() {},
  methods: {
    handleStartMonthChange(selectedStartMonth) {
      if (selectedStartMonth !== null) {
        this.range.start = this.formattedSelectedDate(selectedStartMonth);
        this.state.disabledEndMonth.to = selectedStartMonth;
        this.endMonthDisabled = false;
      } else {
        this.endMonthDisabled = true;
        this.range.start = null;
      }
      this.enableBtnReport();
    },

    handleNoData() {
      this.btnDisabled = true;
      this.isDisplayNoData = true;
    },

    handleEndMonthChange(selectedEndMonth) {
      this.range.end = this.formattedSelectedDate(selectedEndMonth);
      this.enableBtnReport();
    },

    formattedSelectedDate(selectedMonth) {
      if (selectedMonth) {
        const year = selectedMonth.getFullYear();
        const month = String(selectedMonth.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
        return `${year}-${month}`;
      }
      return null;
    },

    enableBtnReport(){
      if( this.selectedMember === null || this.selectedCourseEnroll === null || this.selectedStartMonth === null || this.selectedEndMonth === null ){
        this.btnDisabled = true;
        this.isDisplayNoData = false;
      } else if ( this.selectedStartMonth > this.selectedEndMonth ) {
        this.btnDisabled = true;
        this.selectedEndMonth = null;
        this.isDisplayNoData = false;
      }
      else {
        this.btnDisabled = false;
        this.isDisplayNoData = false;
      }
    },

    calculateAllCoursesLearningDate(courses){
      let overallEarliestStartDate = null;
      let overallLatestLastDate = null;

      courses.forEach(course => {
        let currentStartDate = 0
        let currentLastDate = 0
        if (course['cer_status'] != 'NOT_STARTED') {
          currentStartDate = course['cerStartDate'] ? new Date(course['cerStartDate']) : 0;
          currentLastDate = course['cerLastStudyDate'] ? new Date(course['cerLastStudyDate']) : 0;
        }

        if ((overallEarliestStartDate === null || currentStartDate < overallEarliestStartDate) && currentStartDate > 0) {
          overallEarliestStartDate = currentStartDate;
        }

        if ((overallLatestLastDate === null || currentLastDate > overallLatestLastDate) && currentLastDate > 0) {
          overallLatestLastDate = currentLastDate;
        }
      });

      overallEarliestStartDate = overallEarliestStartDate ? overallEarliestStartDate.toISOString().split('T')[0] : null;
      overallLatestLastDate = overallLatestLastDate ? overallLatestLastDate.toISOString().split('T')[0] : null;

      this.startLearningDate = this.thaiMountYearFilter(overallEarliestStartDate);
      this.lastLearningDate = this.thaiMountYearFilter(overallLatestLastDate);
    },
    
    calculateCourseLearningDate(course){
      let currentStartDate = 0
      let currentLastDate = 0

      if (course['cer_status'] != 'NOT_STARTED') {
        currentStartDate = course['cerStartDate'] ? new Date(course['cerStartDate']).toISOString().split('T')[0] : 0;
        currentLastDate = course['cerLastStudyDate'] ? new Date(course['cerLastStudyDate']).toISOString().split('T')[0] : 0;
      }

      this.startLearningDate = this.thaiMountYearFilter(currentStartDate);
      this.lastLearningDate = this.thaiMountYearFilter(currentLastDate);
    },

    fetchCourseDate() {
      if (this.selectedCoursesStatus != null && this.selectedMember != null) {
        this.selectedCourseEnroll = null;
        this.selectedStartMonth = null;
        this.startMonthDisabled = true;
        this.selectedEndMonth = null;
        this.endMonthDisabled = true;
        this.showDownload = false;
        api.get(`/v1/members/${this.mId}/enrolls?status=${this.cStatus}`).then(({ data }) => {
          this.CourseOptions = data.map(course => ({ label: course.courseName, value: course.cerId }));
          this.CourseOptions.unshift(this.allCourse);
          this.CourseData = data;
        });
      }
    },

    handleClick(){
      this.showDownload = true;
    },

    async checkUserData() {
      let courses = this.CourseData;
      const coursesToKeep = await Promise.all(
        courses.map(async (courseData) => {
          try {
            const { data } = await this.fetchIsCourseAvailable(courseData.cerId);
            if (data) {
              return courseData;
            }
            return null;
          } catch (error) {
            console.error(`Error checking course ${courseData.cerId}:`, error);
            return null;
          }
        })
      );

      this.courseCanDownload = coursesToKeep.filter(course => course !== null);
      this.showDownload = true;
    },

    fetchIsCourseAvailable(cerId) {
      return api.get(`/v1/members/${this.mId}/is-enroll-available/${cerId}?start_month=${this.range.start}&end_month=${this.range.end}&status=${this.cStatus}`);
    },
  },
};
</script>

<style>
.datepickers-container {
  display: flex; 
  align-items: center; 
  gap: 10px; 
}

input,
select {
  padding: 8px;
  font-size: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.no-data {
  font-weight: 600;
  color: #eb8122;
  background-color: #fbe4d0;
  border: 1px solid #f8d7b9;
  padding: 12px 15px;
  border-radius: 4px;
  margin-top: 15px;
}
</style>

